import { createFileRoute } from '@tanstack/react-router'

import { MerchantSettingsScreen } from './-components/merchant-settings-screen.tsx'

export const Route = createFileRoute('/reports/merchant-settings')({
  component: MerchantSettingsScreen
})
